import {MilitaryServiceInfoType, ResumeTabsType} from '../../../../../types/ResumeTypes';
import C from '../ViewerMode.module.scss';
import S from './EtcViewer.module.scss';
import {ConstantUtils} from "../../../../../utils/ConstantUtils";
import _ from "lodash";

interface EtcViewer {
  resumeTabs: ResumeTabsType;
  militaryServiceInfo: MilitaryServiceInfoType;
  veteranStatus: boolean; // 보훈 대상여부
  veteranRelation: string; // 보훈 관계 목록
  disabilityStatus: boolean; // 장애 대상여부
  disabilityGrade: string; // 장애 정도
}

const EtcViewer = (props: EtcViewer) => {
  const {
    resumeTabs,
    disabilityStatus,
    veteranStatus,
    veteranRelation,
    militaryServiceInfo,
    disabilityGrade,
  } = props;
  const militaryStatus = ConstantUtils.convertToMilitaryStatus(militaryServiceInfo?.status || '');

  const booleanTextToKorean = (value: string) => {
    switch (value) {
      case 'true':
        return '예';
      case 'false':
        return '아니오';
      default:
        return '아니오';
    }
  };

  return (
    <>
      <section ref={resumeTabs[5].element} className={`${C.viewer_section} wrapper`}>
        <h4 className={`${C.section_title} h4`}>기타</h4>
        {/* 개별 박스 */}
        <article className={`${C.common_box}`}>
          {/* 상세 내용 */}
          <div className={`${C.profile_text_wrap} ${S.etc_text_wrap}`}>
            {/* 병역 시작 */}
            <div className={C.profile_text_line}>
              <div className={C.text_el_wrap}>
                <h4 className="h4">군필 여부</h4>
                <span className="divided-line" />
                <h4 className="b1">{militaryStatus}</h4>
              </div>
              {militaryServiceInfo?.status === 'Exempt' && (
                <div className={C.text_el_wrap}>
                  <h4 className="h4">군 면제 사유</h4>
                  <span className="divided-line" />
                  <h4 className="b1">{militaryServiceInfo?.reason || ''}</h4>
                </div>
              )}
              {(militaryServiceInfo?.status === 'Completed' ||
                militaryServiceInfo?.status === 'NotCompleted') && (
                  <div className={C.text_el_wrap}>
                    <h4 className="h4">복무시작연월</h4>
                    <span className="divided-line" />
                    <h4 className="b1">{militaryServiceInfo?.startAt}</h4>
                  </div>
                )}

              {militaryServiceInfo?.status === 'Completed' && (
                <div className={C.text_el_wrap}>
                  <h4 className="h4">복무종료연월</h4>
                  <span className="divided-line" />
                  <h4 className="b1">{militaryServiceInfo?.endAt}</h4>
                </div>
              )}
            </div>
            {/* 병역 끝 */}
          </div>
        </article>
        <article className={`${C.common_box}`}>
          {/* 상세 내용 */}
          <div className={`${C.profile_text_wrap} ${S.etc_text_wrap}`}>
            <div className={C.profile_text_line}>
              {/* 취업우대 시작 */}
              { (
                <div className={C.text_el_wrap}>
                  <h4 className="h4">보훈 대상여부</h4>
                  <span className="divided-line" />
                  <h4 className="b1">{booleanTextToKorean(String(veteranStatus))}</h4>
                </div>
              )}
              {veteranStatus && !_.isEmpty(veteranRelation) && (
                <div className={C.text_el_wrap}>
                  <h4 className="h4">보훈 관계</h4>
                  <span className="divided-line" />
                  <h4 className="b1">{veteranRelation}</h4>
                </div>
              )}
              {(
                <div className={C.text_el_wrap}>
                  <h4 className="h4">장애 대상여부</h4>
                  <span className="divided-line" />
                  <h4 className="b1">{booleanTextToKorean(String(disabilityStatus))}</h4>
                </div>
              )}
              {disabilityStatus && !_.isEmpty(disabilityGrade) && (
                <div className={C.text_el_wrap}>
                  <h4 className="h4">장애 정도</h4>
                  <span className="divided-line" />
                  <h4 className="b1">{disabilityGrade}</h4>
                </div>
              )}
            </div>
            {/* 취업우대 끝 */}
          </div>
        </article>
        <hr />
      </section>
    </>
  );
};

export default EtcViewer;
